import React, { useMemo } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { CircularProgress, Box } from '@mui/material';
import MainDashboard from './components/Dashboard/MainDashboard';
import { ErrorBoundary } from './components/ErrorBoundary';
import { LoginForm } from './components/Auth';
import { useAuth } from './hooks/useAuth';
import { ThemeModeProvider, useThemeMode } from './hooks/useThemeMode';
import { getTheme } from './theme';

function AppContent() {
  const { isAuthenticated, loading, login } = useAuth();
  const { mode } = useThemeMode();
  const theme = useMemo(() => getTheme(mode), [mode]);

  if (loading) {
    return (
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh', backgroundColor: 'background.default' }}>
          <CircularProgress size={48} />
        </Box>
      </ThemeProvider>
    );
  }

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <ErrorBoundary>
        {!isAuthenticated ? (
          <LoginForm onLogin={login} />
        ) : (
          <Router>
            <ErrorBoundary>
              <MainDashboard />
            </ErrorBoundary>
          </Router>
        )}
      </ErrorBoundary>
    </ThemeProvider>
  );
}

function App() {
  return (
    <ThemeModeProvider>
      <AppContent />
    </ThemeModeProvider>
  );
}

export default App;
